export default { Loading: '正在載入' };
